function getParams() {
  const queryParametars = new URLSearchParams(window.location.search);
  window.lottery = {
    debugMode: queryParametars.get('debugMode') === 'true',
  };
  return queryParametars;
}
export default getParams;
